import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class DynamicTextBanner extends React.PureComponent<DynamicTextBanner.Props, DynamicTextBanner.State> {
  public static sectionId = 'textban';

  public render(): JSX.Element {
    const { section, data } = this.props

    return (
      <>
        <section className={`dynamic-text-banner bg-${section.settings.backgroundcolour}`}>
          <div className={`${section?.settings?.contained ? "max-w-6xl mx-auto" : "w-full"} p-2 text-center text-${section.settings.textcolour} ${section?.settings?.height == "medium" ? "md:h-30vw md:flex items-center justify-center" : null}`}>
            <Snippets.RichText size={section.settings.issustainablepage ? 2 : 'p'} className={`${section.settings.issustainablepage ? 'font-mono' : null}`}>
              {section.settings.bannercontent}
            </Snippets.RichText>
          </div>
          {section.settings.issustainablepage}
        </section>
      </>
    )
  }
}

export namespace DynamicTextBanner {
  export interface Options extends ShopifyNext.Section<{
    bannercontent: string;
    backgroundcolour: "black" | "white" | "grey";
    textcolour: "black" | "white";
    contained: boolean;
    height: "fluid" | "medium";
    issustainablepage?: boolean;
  }> {}
  export interface Props extends GlobalProps {
    section: DynamicTextBanner.Options;
  }
  export interface State {}
}
